import { useNavigate } from 'react-router-dom';

import {
  adminCloseChat,
  chatActiveTab,
  ClientChatTypes,
  ConfirmationTypes,
  pharmacyHidesChat,
  professionalHidesChat,
} from '@pharmaplan/common';

import { resetDialog } from '../../reducers/dialogReducer';
import { Constants } from '../../helpers/Constants';
import { useAppDispatch } from '../useAppDispatch';
import strings from '../../localization';

import { useAppSelector } from '../useAppSelector';
import useAdmin from '../useAdmin';

const { closeChat: closeChatConfirmation } = ConfirmationTypes;

const { support, pharmacy } = ClientChatTypes;

const useHideChat = (url: string) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { isAdmin } = useAdmin();
  const activeTab = useAppSelector(chatActiveTab);

  const isPharmacy = activeTab === pharmacy;
  const isSupportChat = activeTab === support;

  const userBasedCloseChat = () => {
    if (isAdmin) {
      return { closeChatApi: adminCloseChat, endLabel: strings.endChat };
    }
    if (isSupportChat) {
      return { closeChatApi: adminCloseChat, endLabel: strings.endChat };
    }
    if (isPharmacy) {
      return { closeChatApi: professionalHidesChat, endLabel: strings.hideChat };
    }
    return { closeChatApi: pharmacyHidesChat, endLabel: strings.hideChat };
  };

  const { closeChatApi, endLabel } = userBasedCloseChat();

  const closeChat = () => {
    if (isSupportChat) {
      dispatch(closeChatApi(url));
      navigate(Constants.paths.dashboard);
      dispatch(resetDialog());
    } else {
      dispatch(closeChatApi(url));
    }
  };

  const options = {
    action: closeChat,
    label: endLabel,
    type: closeChatConfirmation,
  };

  return { options };
};

export default useHideChat;
